import {
  AmbientLight,
  BoxGeometry,
  Color,
  Mesh,
  MeshStandardMaterial,
  PerspectiveCamera,
  PointLight,
  Scene,
  SphereGeometry,
  WebGLRenderer,
} from "three";

export class Porthole {
  private readonly scene = new Scene();
  private readonly camera: PerspectiveCamera;
  private readonly renderer: WebGLRenderer;
  private readonly blob: Mesh;
  private raf = 0;
  private t = 0;

  constructor(canvas: HTMLCanvasElement) {
    this.scene.background = new Color(0x1a120c);
    this.camera = new PerspectiveCamera(45, 1, 0.1, 40);
    this.camera.position.set(3.2, 2.4, 3.6);
    this.camera.lookAt(0, 0.6, 0);
    this.renderer = new WebGLRenderer({ canvas, antialias: true });
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    this.renderer.setSize(180, 180, false);

    this.scene.add(new AmbientLight(0xffd6a3, 0.55));
    const lamp = new PointLight(0xffd6a3, 12, 12);
    lamp.position.set(1.4, 2.2, 1.2);
    this.scene.add(lamp);

    const floor = new Mesh(new BoxGeometry(4, 0.08, 4), new MeshStandardMaterial({ color: 0x3a2a18 }));
    floor.position.y = 0;
    this.scene.add(floor);

    const couch = new Mesh(new BoxGeometry(1.6, 0.5, 0.7), new MeshStandardMaterial({ color: 0xc9a44a }));
    couch.position.set(-0.6, 0.3, 0.4);
    this.scene.add(couch);

    this.blob = new Mesh(new SphereGeometry(0.35, 16, 16), new MeshStandardMaterial({ color: 0xff375f }));
    this.blob.position.set(0.5, 0.55, -0.2);
    this.scene.add(this.blob);
  }

  start(): void {
    const tick = () => {
      this.t += 0.016;
      this.blob.position.y = 0.55 + Math.sin(this.t * 2) * 0.12;
      this.renderer.render(this.scene, this.camera);
      this.raf = requestAnimationFrame(tick);
    };
    this.raf = requestAnimationFrame(tick);
  }

  dispose(): void {
    cancelAnimationFrame(this.raf);
    this.renderer.dispose();
  }
}
